import React from "react";
import { useTranslation } from "react-i18next";
import { Mask_Dashboard } from "../../assets/images";
import { ArrowRight } from "../../assets/svgs";
import CustomButton from "../CustomButton";
import UserInitials from "../UserInitials";
import CircularProgressBar from "../CircularProgressBar";
import useApp from "../../hooks/useApp";
import DashboardHeadphoneSVG from "../DashboardHeadphoneSVG";
import DashboardSuccessSVG from "../DashboardSuccessSVG";
import DashboardAlertSVG from "../DashboardAlertSVG";
import "./styles.scss";

const DashboardHeaderStatic = ({
  usersInitials,
  title,
  heading,
  description,
  buttonText,
  onClickInitials,
  onClickCardButton,
  buttonRightIcon,
  isDisabled,
  state,
}) => {
  const { t } = useTranslation();
  const { tenantConfig } = useApp();

  const renderSvgComponent = iconName => {
    switch (iconName) {
      case "dashboard-headphone":
        return <DashboardHeadphoneSVG className="card-svg" />;
      case "dashboard-success":
        return <DashboardSuccessSVG className="card-svg" />;
      case "dashboard-alert":
        return <DashboardAlertSVG className="card-svg" />;
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      <div
        className="dashboard-header-static-container"
        style={{ backgroundImage: `url(${Mask_Dashboard})` }}
      >
        <div className="dashboard-header-static-wrapper">
          <div className="header-content-container">
            <img src={`data:image/png;base64,${tenantConfig?.favicon?.content?.default}` } alt="logo" className="header-logo" />
            <UserInitials
              initialsClass={"header-initials-container"}
              userTextClass={"initials-text"}
              userText={usersInitials}
              onClick={onClickInitials}
            />
          </div>
          <p className="header-heading">{title}</p>
        </div>
      </div>
      <div className="header-card">
        {state?.type === "image" && state?.imageIcon ? (
          <img
            src={state?.imageIcon}
            alt={"card-image"}
            className="card-image"
          />
        ) : null}
        {state?.type === "image" && state?.iconName ? (
          <div className="d-flex justify-content-center mb-4">
            {renderSvgComponent(state?.iconName)}
          </div>
        ) : null}
        {state?.type === "progress" && (
          <CircularProgressBar
            size={108}
            percentage={Number(state.progress)}
            progressBarClassess={"progress-bar"}
            linecap={"round"}
            label={t("global.completed")}
            strokeWidth={10}
          />
        )}
        <p className="card-heading">{heading}</p>
        <p className="card-description">{description}</p>
        {buttonText ? (
          <CustomButton
            disabled={isDisabled}
            onClick={() => onClickCardButton()}
            text={buttonText}
            rightIcon={buttonRightIcon && ArrowRight}
          />
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default DashboardHeaderStatic;
